import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

interface Props {
  onPress?: Function;
  isTaskShare?: boolean;
}

interface State {
  isShow: boolean;
}

export class ShareTipPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress, isTaskShare } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0.02 }}
                end={{ x: 0, y: 0.31 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(30)} />
                <Text style={styles.text}>分享成功</Text>
                <Spacer size={rpx(10)} />
                {isTaskShare ? (
                  <>
                    <Text style={styles.text2}>后续邀请情况和抽奖次数领取</Text>
                    <Text style={styles.text2}>
                      可在<Text style={styles.textYellow}>邀请进度</Text>中查看
                    </Text>
                  </>
                ) : (
                  <>
                    <Text style={styles.text2}>完成邀请新用户任务</Text>
                    <Text style={styles.text2}>可领必中抽奖机会</Text>
                  </>
                )}
                <Spacer size={rpx(14)} />
                {isTaskShare ? (
                  <EmTouchableOpacity
                    activeOpacity={0.9}
                    style={styles.iKnow}
                    onPress={() => {
                      onPress && onPress();
                      this.hide();
                    }}
                  >
                    <Image
                      style={styles.iKnow}
                      source={require('../../images/invite/iKnow.png')}
                      resizeMode={'stretch'}
                    />
                  </EmTouchableOpacity>
                ) : (
                  <EmTouchableOpacity
                    activeOpacity={0.9}
                    onPress={() => {
                      onPress && onPress();
                      this.hide();
                    }}
                  >
                    <Image
                      style={styles.toWatchBtn}
                      source={require('../../images/invite/toWatch.png')}
                      resizeMode={'stretch'}
                    />
                  </EmTouchableOpacity>
                )}
                <Spacer size={rpx(30)} />
              </LinearGradient>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
  },
  iKnow: { width: rpx(210), height: rpx(52) },
  text: {
    fontSize: rpx(24),
    color: '#333333',
    lineHeight: rpx(30),
    fontWeight: 'bold',
  },
  cryImg: {
    width: rpx(115),
    height: rpx(115),
    zIndex: 11,
  },
  text2: {
    fontSize: rpx(15),
    color: '#666666',
    lineHeight: rpx(24),
  },
  btnText: {
    fontSize: rpx(16),
    color: '#ffffff',
  },
  taskBtn: {
    width: rpx(250),
    height: rpx(40),
    borderRadius: rpx(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
  toWatchBtn: {
    width: rpx(211),
    height: rpx(41),
  },
  textYellow: {
    color: '#C8974A',
  },
});
